//#region Imports
import { useCallback, useEffect, useState } from 'react';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Skeleton,
  TextField,
  Typography,
} from '@mui/material';

import { GlobalVariables } from '../../../globalVar';
import customAxios from '../../../utils/customAxios';
import { getToast } from '../../../utils/toastConfig';
//#endregion

const HEADERS = {
  headers: { Authorization: 'bearer ' + localStorage.getItem('token') },
};

export const UpdateBrandModal = ({
  brandId,
  showModal,
  setShowModal,
  refreshData,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [name, setName] = useState('');

  const fetchData = useCallback(async () => {
    setIsFetching(true);
    try {
      const response = await customAxios.get(
        `${GlobalVariables.getURL()}brands/${brandId}`,
        HEADERS,
      );
      const brand = response.data.data || response.data;
      setName(brand?.name || '');
    } catch (error) {
      console.log('Error fetching brand:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    } finally {
      setIsFetching(false);
    }
  }, [brandId]);

  useEffect(() => {
    if (showModal && brandId) fetchData();
  }, [showModal, brandId, fetchData]);

  const handleClose = () => {
    setShowModal(false);
    setName('');
    refreshData();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const response = await customAxios.patch(
        `${GlobalVariables.getURL()}brands/${brandId}`,
        { name },
        HEADERS,
      );
      if (response.status >= 200 && response.status < 300) {
        getToast({
          status: 'success',
          title: 'Marca actualizada exitosamente en la base de datos.',
        });
        handleClose();
      }
    } catch (error) {
      console.log('Error updating brand:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={showModal} maxWidth='sm' fullWidth onClose={handleClose}>
      <DialogTitle>
        <Typography className='inventory-movmodal-title'>
          Editar marca
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={handleClose}
        sx={{ position: 'absolute', right: 20, top: 20, width: 40, height: 40 }}
      >
        <FontAwesomeIcon icon={faTimes} />
      </IconButton>
      <DialogContent dividers>
        <form id='update-brand-form' onSubmit={handleSubmit}>
          {isFetching ? (
            <Skeleton variant='rectangular' width='100%' height={56} />
          ) : (
            <TextField
              required
              fullWidth
              disabled={isLoading}
              label='Nombre'
              placeholder='Nombre...'
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
          )}
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          form='update-brand-form'
          type='submit'
          disabled={isLoading || isFetching}
        >
          {isLoading ? (
            <CircularProgress size='2rem' />
          ) : (
            <Typography>Guardar</Typography>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
